<nz-table
    #basicTable
    [nzData]="data"
    [nzLoading]="loading"
    [nzScroll]="{ x: '3500px', y: '500px' }"
    [nzFrontPagination]="false"
    [nzTotal]="totalRows"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    (nzPageIndexChange)="onPageChange($event)"
    [nzShowTotal]="totalTemplate"
>
    <thead>
        <tr>
            <th nzLeft nzWidth="150px">Sub Category</th>
            <th nzWidth="130px">Planned Options</th>
            <th nzWidth="100px">Options</th>
            <th nzWidth="100px">SKU's</th>
            <th nzWidth="100px">CP</th>
            <th nzWidth="100px">RRP</th>
            <th nzWidth="120px">Price Inc %</th>
            <th nzWidth="150px">Weighted Margin %</th>
            <th nzWidth="150px">Planned buy units</th>
            <th nzWidth="130px">Total Unit Sales</th>
            <th nzWidth="150px">Confirm PO Units</th>
            <th nzWidth="130px">PO Sell Thru</th>
            <th nzWidth="180px">Extnd Risk Value @ Cost</th>
            <th nzWidth="200px">Extnd Retail Sales Value</th>
            <th nzWidth="120px">Budget</th>
            <th nzWidth="120px">Var to bud</th>
            <th nzWidth="100px">% SOB</th>
            <th nzWidth="120px">Plan SOB%</th>
            <th nzWidth="120px">SKU Efficiency</th>
            <th nzWidth="140px">Plan unit sales</th>
            <th nzWidth="180px">Plan wholesale value</th>
            <th nzWidth="120px">Plan GP%</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngIf="data" class="totals-row">
            <td nzLeft class="totals-cell">Total</td>
            <td class="totals-cell">{{ formatNumber(totals.plannedOptions) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.options) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.skuPlan) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.finalAllInclusiveUnitCost) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.suggestedRetailPrice) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.priceIncrease) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.weightedMargin) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.originalPlannedUnits) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.totalUnitSales) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.confirmedPurchaseOrderUnits) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.purchaseOrderSellThrough) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.extendedRiskValueCost) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.extendedRetailSalesValue) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.budget) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.variance) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.shareOfBusinessPercentage) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.plannedShareOfBusiness) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.skuEfficiency) }}</td>
            <td class="totals-cell">{{ formatNumber(totals.plannedUnitSales) }}</td>
            <td class="totals-cell">{{ formatCurrency(totals.plannedWholesaleValue) }}</td>
            <td class="totals-cell">{{ formatPercentage(totals.plannedGrossPricePercentage) }}</td>
        </tr>
        <tr *ngFor="let item of basicTable.data">
            <td nzLeft>{{ item.subCategoryId }}</td>
            <td>{{ formatNumber(item.plannedOptions) }}</td>
            <td>{{ formatNumber(item.options) }}</td>
            <td>{{ formatNumber(item.skuPlan) }}</td>
            <td>{{ formatCurrency(item.finalAllInclusiveUnitCost) }}</td>
            <td>{{ formatCurrency(item.suggestedRetailPrice) }}</td>
            <td>{{ formatPercentage(item.priceIncrease) }}</td>
            <td>{{ formatPercentage(item.weightedMargin) }}</td>
            <td>{{ formatNumber(item.originalPlannedUnits) }}</td>
            <td>{{ formatNumber(item.totalUnitSales) }}</td>
            <td>{{ formatNumber(item.confirmedPurchaseOrderUnits) }}</td>
            <td>{{ formatPercentage(item.purchaseOrderSellThrough) }}</td>
            <td>{{ formatCurrency(item.extendedRiskValueCost) }}</td>
            <td>{{ formatCurrency(item.extendedRetailSalesValue) }}</td>
            <td>{{ formatCurrency(item.budget) }}</td>
            <td>{{ formatCurrency(item.variance) }}</td>
            <td>{{ formatPercentage(item.shareOfBusinessPercentage) }}</td>
            <td>{{ formatPercentage(item.plannedShareOfBusiness) }}</td>
            <td>{{ formatPercentage(item.skuEfficiency) }}</td>
            <td>{{ formatNumber(item.plannedUnitSales) }}</td>
            <td>{{ formatCurrency(item.plannedWholesaleValue) }}</td>
            <td>{{ formatPercentage(item.plannedGrossPricePercentage) }}</td>
        </tr>
    </tbody>
</nz-table>

<ng-template #totalTemplate let-total>
    Total {{ total }} items
</ng-template>
